<div class="tooltip-wrapper" [class]="position" (mouseenter)="showOverlay()" (mouseleave)="hideOverlay()">

  <div class="tooltip-trigger">
    <ng-content></ng-content>
  </div>

  <div class="overlay-content" #versionOverlay *ngIf="isVisible">
    <div class="overlay-header">
      <i>©</i>
      <span>DATAMEAL ONLINE</span>
    </div>

    <div class="d-flex flex-column">
      <table>
        <tbody>
          <tr>
            <td>
              <i class="cursor fas fa-tag" title="version"></i>
            </td>
            <td>
              Version
            </td>
            <td>
              {{dolVersionJson.latestTag}}
            </td>
          </tr>
          <tr>
            <td>
              <i class="cursor fas fa-code-branch" title="branche"></i>
            </td>
            <td>
             Branche
            </td>
            <td>
              {{dolVersionJson.branch}}
            </td>
          </tr>
          <tr>
            <td>
              <i class="cursor fas fa-hashtag" title="hash"></i>
            </td>
            <td>
              Hash
            </td>
            <td>
              {{dolVersionJson.shortHash}}
            </td>
          </tr>
          <tr>
            <td>
              <i class="cursor fas fa-code" title="date des sources"></i>
            </td>
            <td>
             Date des sources
            </td>
            <td>
              {{utils.customFormatDate(dolVersionJson.dateCommit, 'DD/MM/YYYY-HH:mm:ss', 'DD/MM/YYYY HH:mm:ss')}}
            </td>
          </tr>
          <tr>
            <td>
              <i class="cursor fas fa-code" title="compilé le"></i>
            </td>
            <td>
             Compilé le
            </td>
            <td>
              {{utils.customFormatDate(dolVersionJson.dateBuild, 'DD/MM/YYYY-HH:mm:ss', 'DD/MM/YYYY HH:mm:ss')}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
